/**
 * This file is part of the Valkyrie Robotics public website.
 * © 2025 Valkyrie Robotics, LLC. All rights reserved.
 */

import { PropsWithChildren } from "react";

type SectionProps = PropsWithChildren<{
  title?: string;
  subtitle?: string;
  id?: string;
}>;

export function Section({ title, subtitle, id, children }: SectionProps) {
  return (
    <section id={id} className="mx-auto max-w-6xl px-4 py-20">
      {(title || subtitle) && (
        <header className="mb-10">
          {title && (
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="mt-3 text-lg text-gray-300 max-w-3xl">{subtitle}</p>
          )}
        </header>
      )}
      {children}
    </section>
  );
}
